module.exports = __webpack_public_path__ + "img/4_153.b902eca1.png";